import { createSelector } from 'reselect';
import { RootState } from '../store';

export const formInputs = (state: RootState) => state.formInputs;

export const getValueFields = (state: RootState) => state.formInputs.values;

export const getDefaultValueFields = (state: RootState) =>
  state.formInputs.defaultValues;
